import type { ICD10Code } from "./icd10-common";

// Full ICD-10-CM library via the NLM Clinical Tables API — the ICD counterpart
// to the RxNorm medication API in `rxterms.ts` (same provider). Lets the manual
// diagnosis pickers fall back from the bundled common-codes list to the entire
// ICD-10-CM set (~70k codes) without bundling them into the app.
const API_BASE = "https://clinicaltables.nlm.nih.gov/api/icd10cm/v3/search";

export async function searchFullICD10(query: string, maxList = 20): Promise<ICD10Code[]> {
    if (!query || query.length < 2) {
        return [];
    }

    const url = `${API_BASE}?terms=${encodeURIComponent(query)}&maxList=${maxList}&sf=code,name&df=code,name`;
    try {
        const res = await fetch(url);
        if (!res.ok) {
            return [];
        }

        const data = await res.json();
        // Response format: [count, [codes], extra|null, [[code, name], ...]]
        const display = (data as [number, string[], unknown, string[][]])[3];
        if (!Array.isArray(display)) {
            return [];
        }

        return display
            .filter((row) => Array.isArray(row) && row.length >= 2)
            .map((row) => ({ code: row[0], description: row[1] }));
    } catch {
        // Offline / network error — caller keeps the local results.
        return [];
    }
}
